const sanctumConfig = {
    apiUrl: "https://api.admin.ltdd-studio.fr",
    //apiUrl: "http://localhost:8000",
    csrfCookieRoute: "sanctum/csrf-cookie",
    signInRoute: "login",
    signOutRoute: "logout",
    userObjectRoute: "api/user",
};

export default sanctumConfig
